import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=090f0fac&scoped=true"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f0fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090f0fac')) {
      api.createRecord('090f0fac', component.options)
    } else {
      api.reload('090f0fac', component.options)
    }
    module.hot.accept("./categoryList.vue?vue&type=template&id=090f0fac&scoped=true", function () {
      api.rerender('090f0fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/videoChannel/weChatcategoryAndBrand/categoryList.vue"
export default component.exports